import configService from "../services/configService";

export type TournamentBulkResource = "teams" | "players" | "fixtures" | "player-stats";

export interface BulkTemplate {
  path: string;
  label: string;
}

const PLAYER_STAT_TEMPLATE_BY_SPORT: Record<string, string> = {
  chess: "web/templates/player-stats-chess-template.xlsx",
  tabletennis: "web/templates/player-stats-tabletennis-template.xlsx",
  swimming: "web/templates/player-stats-swimming-template.xlsx",
  speedskating: "web/templates/player-stats-speedskating-template.xlsx",
  pickleball: "web/templates/player-stats-pickleball-template.xlsx",
  padel: "web/templates/player-stats-padel-template.xlsx",
  football: "web/templates/player-stats-football-template.xlsx",
  cricket: "web/templates/player-stats-cricket-template.xlsx",
  basketball: "web/templates/player-stats-basketball-template.xlsx",
};

const FIXTURE_TEMPLATE_BY_SPORT: Record<string, string> = {
  football: "web/templates/Football_match_bulk_upload_template.xlsx",
  tennis: "web/templates/Tennis_match_bulk_upload_template.xlsx",
  tabletennis: "web/templates/Table_Tennis_match_bulk_upload_template.xlsx",
  badminton: "web/templates/Badminton_match_bulk_upload_template.xlsx",
  padel: "web/templates/Padel_match_bulk_upload_template.xlsx",
  pickleball: "web/templates/Pickleball_match_bulk_upload_template.xlsx",
  basketball: "web/templates/Basketball_match_bulk_upload_template.xlsx",
  cricket: "web/templates/Cricket_match_bulk_upload_template.xlsx",
  chess: "web/templates/Chess_match_bulk_upload_template.xlsx",
  swimming: "web/templates/Swimming_match_bulk_upload_template.xlsx",
  speedskating: "web/templates/Speed_Skating_match_bulk_upload_template.xlsx",
};

const GENERIC_FIXTURE_TEMPLATE =
  "web/templates/Generic_Sport_match_bulk_upload_template.xlsx";

export const normalizeTemplateSport = (sport?: string): string => {
  const normalized = (sport || "").toLowerCase().replace(/[^a-z0-9]/g, "");
  if (normalized === "skating") return "speedskating";
  if (normalized === "tt") return "tabletennis";
  return normalized;
};

export function getBulkTemplate(
  resource: TournamentBulkResource,
  sport?: string
): BulkTemplate | undefined {
  if (resource === "teams") {
    return { label: "Teams template", path: "web/templates/teams-template.xlsx" };
  }

  if (resource === "players") {
    return { label: "Players template", path: "web/templates/players-template.xlsx" };
  }

  if (resource === "fixtures") {
    const path =
      FIXTURE_TEMPLATE_BY_SPORT[normalizeTemplateSport(sport)] ||
      GENERIC_FIXTURE_TEMPLATE;
    return { label: "Fixtures template", path };
  }

  const path = PLAYER_STAT_TEMPLATE_BY_SPORT[normalizeTemplateSport(sport)];
  return path ? { label: "Player stats template", path } : undefined;
}

export function getBulkTemplateUrl(
  resource: TournamentBulkResource,
  sport?: string
): string | undefined {
  const template = getBulkTemplate(resource, sport);
  if (!template) return undefined;

  const baseUrl = configService.getCdnBaseUrl().replace(/\/$/, "");
  return `${baseUrl}/${template.path}`;
}
